"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
function enumKeys(anyEnum) {
    return Object.keys(anyEnum)
        .map(key => anyEnum[key])
        .filter(value => typeof value === 'string');
}
exports.enumKeys = enumKeys;
function enumMap(anyEnum) {
    return _.pickBy(anyEnum, value => typeof value === 'string');
}
exports.enumMap = enumMap;



//////////////////
// WEBPACK FOOTER
// ./src/logic/enumValues.ts
// module id = 118
// module chunks = 0 1